
if ( typeof VideoBackgroundElement !== 'function' ) {

  class VideoBackgroundElement extends HTMLElement {

    constructor(){

      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      const video = this.querySelector('video');
      this.playOnHover = this.hasAttribute('data-play-on-hover');
      this.externalVideo = this.hasAttribute('data-external-video');
      video?.addEventListener('error', e=>{
        this.switchFallback();
      })
      video?.addEventListener('playing', e=>{
        if ( ! this.classList.contains('loaded') ) {
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }
      })
      video?.addEventListener('stalled', e=>{
        if ( ! this.classList.contains('loaded') ) {
          this.switchFallback();
        }
      })

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting || this.hasAttribute('data-external-video')) return;
        if ( ( entries[0].target.querySelector('video-background-element') && ! entries[0].target.querySelector('video-background-element').classList.contains('loaded') ) || ( entries[0].tagName == 'video-background-element') && ! entries[0].target.classList.contains('loaded') ) {
          this.loadVideo(video);
        }
        observer.unobserve(this);
      }

      if (!this.hasAttribute('data-external-video') && (this.getBoundingClientRect().y < window.innerHeight || this.parentNode.getBoundingClientRect().y < window.innerHeight) ) {
        this.loadVideo(video);
      } else {
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this);
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this.parentElement);
      }

      if (this.playOnHover) {
        const productItem = this.closest('[data-js-product-item]');

        if (productItem) {
          productItem.addEventListener('mouseenter', () => {
            if (this.externalVideo) {
              this.appendExternalVideo();
            } 
            
            this.play(video);
          });

          productItem.addEventListener('mouseleave', () => {
            if (this.externalVideo) {
              this.removeExternalVideo();

              return;
            }

            this.pause(video);
          });
        } else {
          this.addEventListener('mouseenter', () => {
            if (this.externalVideo) {
              this.appendExternalVideo();
            } 
            
            this.play(video);
          });

          this.addEventListener('mouseleave', () => {
            if (this.externalVideo) {
              this.removeExternalVideo();

              return;
            }

            this.pause(video);
          });
        }
      }
    }

    switchFallback(){
      const fallback = this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if ( fallback ) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));
        fallback.querySelector('img').setAttribute('srcset', fallback.querySelector('img').getAttribute('srcset'));
      }
      this.dispatchEvent(this._eventFail);
    }

    play(video) {
      if (this.externalVideo) {
        if ( this.querySelector('.js-youtube') ) {
          this.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }

        if ( this.querySelector('.js-vimeo') ) {
          this.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
        }

        return;
      }

      this.loadVideo(video);

      video?.play();
    }

    pause(video) {
      this.loadVideo(video);

      video?.pause();
    }

    loadVideo(video) {
      if (this.classList.contains('loaded')) {
        return;
      }

      video.querySelectorAll('source').forEach(elm => {
        elm.src = elm.dataset.src;
      });

      video.load();

      this.classList.add('loaded');
    }

    appendExternalVideo() {
      this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
    }

    removeExternalVideo() {
      this.querySelector('iframe').remove();
    }
  }

  if ( typeof customElements.get('video-background-element') == 'undefined' ) {
    customElements.define('video-background-element', VideoBackgroundElement);
  }
}

document.addEventListener('shopify:section:load', e=>{
  if ( e.target.classList.contains('mount-video-background') ) {
    setTimeout(()=>{
      e.target.querySelectorAll('video-background-element').forEach(elm=>{
        elm.querySelectorAll('source').forEach(source=>{
          source.src = source.dataset.src;
        })
        elm.querySelector('video').load();
      });
    }, 500);
  }
});